/** Impl do use case de HistoricoEscolar. @since G.5.7 */
import type { HistoricoEscolar } from '@/domain/model/HistoricoEscolar';
import type { HistoricoEscolarGateway } from '@/application/port/out/HistoricoEscolarGateway';
import type { GetHistoricoEscolarUseCase } from '@/application/port/in/HistoricoEscolarUseCase';

export class GetHistoricoEscolar implements GetHistoricoEscolarUseCase {
  constructor(private readonly g: HistoricoEscolarGateway) {}
  execute(alunoId: string): Promise<HistoricoEscolar> { return this.g.getByAluno(alunoId); }
}
